import { memo, useEffect } from 'react';

import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanChapters } from 'store/useBusinessToolStore/selectors';

import { getLastPageProps } from './mapping';

interface ILastPageProps {
  saveSectionProps: (key: string, props: Record<string, any>) => void;
}

export const LastPage = memo(({ saveSectionProps }: ILastPageProps) => {
  const businessPlanChapters = useBusinessToolStore(getBusinessPlanChapters);
  const props = getLastPageProps(businessPlanChapters);

  useEffect(() => {
    saveSectionProps('lastPage', props);
  }, []);

  return null;
});
